import { useIntl, FormattedMessage } from 'react-intl';

import { Tag } from '../Tag';

interface IProps {
  date: Date;
  timezone?: string;
}

const TransferStatus = ({ date, timezone }: IProps) => {
  const intl = useIntl();

  return (
    <Tag>
      <FormattedMessage
        defaultMessage="Leaving {date}"
        id="45AszA"
        description="Driver's transfer date label"
        values={{
          date: intl.formatDate(date, {
            month: '2-digit',
            day: 'numeric',
            timeZone: timezone,
          }),
        }}
      />
    </Tag>
  );
};

export { TransferStatus };
